// extracted by mini-css-extract-plugin
export default {"unsavedChangeBox":"unsavedBrandWarning_unsavedChangeBox__9eYl0","modalBody":"unsavedBrandWarning_modalBody__XGMb8","warningMessage":"unsavedBrandWarning_warningMessage__f6WcO"};